import {
  MONTH,
  YEAR,
  TRIAL,
  monthPrice,
  annualPrice,
  trialPrice,
  CHALLENGE
} from '../utils/stripePrices'
import usePricing from '../../redux/pricing/usePricing'

export const useSubscriptions = (isAffiliated?: boolean) => {
  // Get price data
  const { actions: { getPriceData } } = usePricing()
  const monthPriceData = getPriceData('subscription', monthPrice)!
  const annualPriceData = getPriceData('subscription', annualPrice)!
  const trialPriceData = getPriceData('subscription', trialPrice)!

  const annualOnSale = isAffiliated || !!annualPriceData?.sale
  const monthOnSale = isAffiliated || !!monthPriceData?.sale

  const affiliateAnnualPrice = isAffiliated && 449
  const affiliateMonthPrice = isAffiliated && 34

  // Returns the subscription's sale price
  const getSalePrice = (type: typeof YEAR | typeof MONTH, returnOriginalPrice?: boolean) => {
    if (type === MONTH && monthPriceData?.sale?.valueAfterDiscount) {
      return monthPriceData?.sale?.valueAfterDiscount
    }

    if (type === MONTH && affiliateMonthPrice) {
      return affiliateMonthPrice
    }

    if (type === MONTH && returnOriginalPrice) {
      return monthPriceData?.price
    }

    if (type === YEAR && annualPriceData?.sale?.valueAfterDiscount) {
      return annualPriceData?.sale?.valueAfterDiscount
    }

    if (type === YEAR && affiliateAnnualPrice) {
      return affiliateAnnualPrice
    }

    if (type === YEAR && returnOriginalPrice) {
      return annualPriceData?.price
    }
  }

  return {
    monthPriceData,
    annualPriceData,
    trialPriceData,
    subscriptions: [
      {
        id: YEAR,
        name: 'Annual Subscription',
        description: `$${getSalePrice(YEAR, true)} /${annualOnSale ? 'first ' : ''}year`,
        sizzle: annualOnSale ? `Billed $${annualPriceData?.price} after` : 'Save $89',
        plan: annualPriceData,
        price: annualPriceData?.price,
        salePrice: getSalePrice(YEAR)
      },
      {
        id: MONTH,
        name: 'Monthly Subscription',
        description: `$${getSalePrice(MONTH, true)} /${monthOnSale ? 'first ' : ''}month`,
        sizzle: monthOnSale ? `Billed $${monthPriceData?.price} after` : 'Billed Monthly',
        plan: monthPriceData,
        price: monthPriceData?.price,
        salePrice: getSalePrice(MONTH)
      },
      {
        id: TRIAL,
        name: 'Free Trial',
        description: 'Continue to Free Trial',
        sizzle: 'Enjoy 14 days for free',
        plan: trialPriceData,
        price: 0,
        hidden: true
      },
      {
        id: CHALLENGE,
        name: 'Free Challenge',
        description: 'Continue to Free Trial',
        sizzle: 'Enjoy 14 days for free',
        plan: trialPriceData,
        price: 0,
        hidden: true
      }
    ]
  }
}
